export const supporterList = [
    { name: 'Adam Sinclair', link: '' },
    { name: 'MJ', link: '' },
    { name: 'AndyXT', link: 'https://youtube.com/channel/UCPAhnTuZQhGnCV46AVN3sdw' },
    { name: 'King Kush', link: 'https://www.youtube.com/channel/UCisSpJBDQdIax6DTTMS0eDg' },
    { name: 'Ben Del Vacchio', link: 'https://www.youtube.com/channel/UCisSpJBDQdIax6DTTMS0eDg'},
    { name: 'Zirteq', link: 'https://youtube.com/@ZirTeq/videos' },
    { name: 'Kewk', link: 'https://twitter.com/kewkd' },
    { name: 'BinaryLady at TheTechMargin', link: 'https://bio.site/techmargin' },
    { name: 'ascendant', link: 'https://tiktok.com/@malaclypse23' },
    { name: 'Koshi Mazaki', link: 'https://glitchcandies.art/spectralshift/' }, 
    { name: 'lexvesseur', link: '' }, 
    { name: 'Andreas Lewitzki', link: 'https://www.youtube.com/@ro0otz' }, 
    { name: 'veryVANYA', link: 'https://twitter.com/veryVANYA'},
    { name: 'Nenad Kuzmanovic', link: '' },
    { name: 'Stash', link: ''},
    { name: 'Sani', link: ''},
    { name: 'Lottery Discountz', link: ''},
    { name: 'Sinneys', link: ''},
    { name: 'Ronny Khalil', link: 'https://ronnykhalil.com/'},
    { name: 'k_nearest_neighbor', link: 'https://ai-breakout.com/'},
    { name: 'Hybridizer', link: 'https://www.instagram.com/hybridizerart/'},
    { name: 'Sithandwesson', link: ''},
    

] 